import BaseService from "./Base.Service";

class TaxInvoiceService extends BaseService {
    constructor() {
        const model = {
            employee: { type: String, required: true },
            month: { type: String, required: true },
            companyId: { type: String, required: true },
            documentURI: { type: String, required: true },
        };

        super("tax-invoices", model);
    }

    async uploadTaxInvoice(formData) {
        try {
            const { data } = await this.conn.axios.post(`/tax-invoices/upload-tax-invoice`, formData, { headers : { 'Content-Type' : 'multipart/formdata' } });
            return data;
        } catch (err) {
            const msg = err?.response?.data?.msg || err?.response?.data || "Erro ao enviar nota fiscal";
            return this.sendError(msg, err?.response?.status, err);
        }
    }

    async getDocument(filename, userId = null) {
        try {
            const { data } = await this.conn.axios({
                method: 'GET',
                url: `/tax-invoices/get-file?filename=${filename}&userId=${userId}`,
                responseType: 'blob'
            });
            // Se o backend retornou JSON com URL (S3), extrair do blob
            if (data instanceof Blob && data.type === 'application/json') {
                const text = await data.text();
                return JSON.parse(text);
            }
            return data;
        } catch (err) {
            return this.sendError("Erros foram encontrados ao recuperar a nota", false, err);
        }
    }

    async approve(id) {
        try {
            const { data } = await this.conn.axios.put(`/tax-invoices/${id}/approve`);
            return data;
        } catch (err) {
            return this.sendError("Erro ao aprovar nota fiscal", false, err);
        }
    }

    async reject(id, reason) {
        try {
            const { data } = await this.conn.axios.put(`/tax-invoices/${id}/reject`, { reason });
            return data;
        } catch (err) {
            return this.sendError("Erro ao rejeitar nota fiscal", false, err);
        }
    }

    async registerPayment(id, paid_at) {
        try {
            const { data } = await this.conn.axios.put(`/tax-invoices/${id}/register-payment`, { paid_at });
            return data;
        } catch (err) {
            return this.sendError("Erro ao registrar pagamento", false, err);
        }
    }
}

export default TaxInvoiceService;
